// extracted by mini-css-extract-plugin
export var productImage = "_102-0";